import { UUID } from './measurementCore';
import { isLanderPreview } from '../experiments/assignment';
const TRACKING_KEY = 'parables:tracking:uid';
const productionHost = ['readparables.com', 'www.readparables.com', 'start.readparables.com', 'lander.readparables.com'].includes(location.hostname);
export const measurementEnvironment = import.meta.env.MODE === 'test' ? 'test' : import.meta.env.DEV ? 'development' : import.meta.env.MODE === 'preview' || !productionHost ? 'preview' : 'production';
export const measurementIsTest = measurementEnvironment !== 'production' || ['localhost', '127.0.0.1'].includes(location.hostname) || import.meta.env.VITE_ANALYTICS_TEST === 'true' || isLanderPreview(location.search);
// Every visitor is measured. Test and preview journeys may reach product analytics, never ad delivery.
export const measuresMarketing = !measurementIsTest;
let memoryUid: string | undefined;
export function getTrackingUuid(): string {
  if (memoryUid) return memoryUid;
  try { const existing = localStorage.getItem(TRACKING_KEY); if (existing && UUID.test(existing)) return memoryUid = existing; } catch { /* Storage optional. */ }
  memoryUid = crypto.randomUUID();
  try { localStorage.setItem(TRACKING_KEY, memoryUid); } catch { /* Storage optional. */ }
  return memoryUid;
}
